<template>
  <div>
    <top-navbar></top-navbar>

    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Project Management
      </h6>

      <div style="padding-bottom: 100px" class="container-fluid">
        <div style="border: 0px; padding: 0px; min-height:0px" class="navbar background_color">
          <div class="d-flex">
            <b-input-group size="sm" style="width: 225px;">
              <b-form-input
                id="filter-input"
                class="bdr-rad"
                v-model.trim="searchTerm"
                type="search"
                placeholder="Search"
              ></b-form-input>
            </b-input-group>
            <div style="margin-top: 11px;" class="ms-2">
              <span class="custom-breadcrumb">Showing {{ paginationStart }}-{{ paginationEnd }} of {{ totalRows }} items.</span>
            </div>
          </div>

          <div class="d-grid gap-2 d-md-flex justify-content-md-end">
            <router-link to="/projectmanagement/create" class="btn btn-sm btn-outline-primary mb-1 mt-0 bdr-rad font-size_def">
              Create Project
            </router-link>
          </div>
        </div>

        <div class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body">
            <div v-if="loading" class="d-flex justify-content-center">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>

            <template v-else>
              <div class="table-responsive">
                <table style="font-size: small;" class="table table-hover table-sm table-bordered">
                  <thead class="project-table-head">
                    <tr class="custom-label2">
                      <th>#</th>
                      <th>Project Name</th>
                      <th>Sponsor</th>
                      <th>Site</th>
                      <th>CRC</th>
                      <th>Investigators</th>
                      <th>Screening Date</th>
                      <th class="text_right">Visits</th>
                      <th class="text_right">Created Date</th>
                      <th class="text_right">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in pagedRows" :key="row.id">
                      <td>{{ (currentPage - 1) * perPage + index + 1 }}</td>
                      <td>{{ row.project_name || "-" }}</td>
                      <td>{{ row.sponsor_name || "-" }}</td>
                      <td>{{ row.site || "-" }}</td>
                      <td>{{ row.crc_name || "-" }}</td>
                      <td>{{ formatList(row.investigator_names) }}</td>
                      <td>{{ formatDate(row.screening_date) }}</td>
                      <td class="text_right">{{ row.number_of_visit || 0 }}</td>
                      <td class="text_right">{{ row.created_date || "-" }}</td>
                      <td class="text_right">
                        <div class="dropdown">
                          <button class="btn btn-sm btn-outline-primary dropdown-toggle bdr-rad" type="button" data-toggle="dropdown" aria-expanded="false">
                            Action
                          </button>
                          <div class="dropdown-menu bdr-rad">
                            <router-link :to="'/projectmanagement/view?id=' + row.id" class="dropdown-item">
                              View
                            </router-link>
                            <router-link :to="'/projectmanagement/create?id=' + row.id" class="dropdown-item">
                              Edit
                            </router-link>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="!pagedRows.length">
                      <td colspan="10" class="text-center text-muted">No project records found.</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="mt-3 d-flex justify-content-start">
                <b-pagination
                  v-model="currentPage"
                  pills
                  :total-rows="totalRows"
                  :per-page="perPage"
                  size="sm"
                ></b-pagination>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from "axios";
import authService from "@/auth.service";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";

export default {
  components: {
    ContentFooter,
    TopNavbar,
  },

  data() {
    return {
      access_token: authService.isLoggedIn(),
      loading: false,
      rows: [],
      searchTerm: "",
      currentPage: 1,
      perPage: 15,
    };
  },

  computed: {
    filteredRows() {
      const term = this.searchTerm.toLowerCase();

      if (!term) {
        return this.rows;
      }

      return this.rows.filter((row) =>
        [
          row.project_name,
          row.sponsor_name,
          row.site,
          row.crc_name,
          row.created_date,
          row.screening_date,
          this.formatList(row.investigator_names),
        ]
          .filter((value) => value !== null && value !== undefined)
          .some((value) => String(value).toLowerCase().includes(term))
      );
    },

    totalRows() {
      return this.filteredRows.length;
    },

    pagedRows() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.filteredRows.slice(start, start + this.perPage);
    },

    paginationStart() {
      return this.totalRows ? (this.currentPage - 1) * this.perPage + 1 : 0;
    },

    paginationEnd() {
      return this.totalRows ? Math.min(this.currentPage * this.perPage, this.totalRows) : 0;
    },
  },

  watch: {
    searchTerm() {
      this.currentPage = 1;
    },
  },

  mounted() {
    this.loadRows();
  },

  methods: {
    formatDate(value) {
      if (!value) {
        return "-";
      }

      const [year, month, day] = String(value).split("-");
      return year && month && day ? `${day}/${month}/${year}` : value;
    },

    formatList(values) {
      return Array.isArray(values) && values.length ? values.join(", ") : "-";
    },

    async loadRows() {
      this.loading = true;

      try {
        const { data } = await axios.get("/projectmanagement/indexload", {
          headers: {
            Authorization: "Bearer " + this.access_token,
            "Content-type": "application/json",
          },
        });

        if (data.status === 200) {
          this.rows = data.data || [];
        }
      } catch (error) {
        console.error(error.response || error);
        alert("Error loading project list.");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.project-table-head {
  background-color: #ECF7FF;
}

.project-table-head tr th {
  color: #1f2d3d;
  border-bottom: 1px solid #7f98ae;
}

.table-bordered th,
.table-bordered td {
  border-left: none !important;
  border-right: none !important;
}
</style>
